var A = /* @__PURE__ */ ((E) => (E[E.MALE = 1] = "MALE", E[E.FEMALE = 2] = "FEMALE", E[E.OTHER = 3] = "OTHER", E[E.NA = 4] = "NA", E))(A || {});
export {
  A as Gender
};
//# sourceMappingURL=gender.js.map
